import { Amount, Promotion } from '@api';
import * as React from 'react';
import { Fragment } from 'react';
import { scrollToTop } from 'src/js/common/utils/DomUtils';
import { ChechoutRedeemVoucher } from 'src/js/model/checkout/RedeemVoucher';
import AmountComp from '../../../components/AmountComp';
import { Tabs } from '../reducers/State';

export interface Props {
  paymentForm: React.ReactElement;
  amount: Amount;
  onAddCode:(code: string) => void;
  promotions: Promotion[];
  redeemVouchers?: ChechoutRedeemVoucher[];
  redeemedVoucherProducts?: ChechoutRedeemVoucher[];
  onToggleVoucher?: (redeemVoucher, enabled) => void;
  onToggleVoucherProduct?: (redeemVoucher, enabled) => void;
  onUpdatePayNow?: (val, validate?: boolean) => void;
  onInit?: () => void;
  currentTab: Tabs;
}

export class PaymentComp extends React.Component<Props, any> {
  componentDidMount() {
    scrollToTop();
  }

  render() {
    const { amount, onAddCode, paymentForm, promotions, onUpdatePayNow, onToggleVoucher,
      redeemVouchers, redeemedVoucherProducts, onToggleVoucherProduct, currentTab } = this.props;
    return (
      <Fragment>
        <div className="row">
          <div className="col-24 col-xs-24">
            <div className="row amount-container">
              <AmountComp
                amount={amount}
                onAddCode={onAddCode}
                promotions={promotions}
                onUpdatePayNow={amount.isEditable ? onUpdatePayNow : undefined}
                onToggleVoucher={onToggleVoucher}
                onToggleVoucherProduct={onToggleVoucherProduct}
                redeemVouchers={redeemVouchers}
                redeemedVoucherProducts={redeemedVoucherProducts}
                currentTab={currentTab}
              />
            </div>
          </div>
        </div>
        {paymentForm}
      </Fragment>
    );
  }
}
